export default __webpack_public_path__ + "static/media/lato-bolditalic.d23e5e39.ttf";